import AuthContext from '../../context/AuthContext'
import { Breadcrumb, BreadcrumbItem } from 'carbon-components-react'
import React, { useEffect, useState, useMemo, useContext } from 'react'
import { AgreementsList } from './submissionList.tsx'
import Toast from '../../components/Notification/Toast'
const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;

const API_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const SubmissionList = () => {

    let { authTokens } = useContext(AuthContext)

    const [list, setList] = useState([]);
    let toastProperties = null;
    let [openDeleteModal, setOpenDeleteModal] = useState(false)
    let [error, setError] = useState(null)
    let [clientsToDel, setClientsToDel] = useState(null)

    const [totalItems, setTotalItems] = useState(0);
    const [firstRowIndex, setFirstRowIndex] = useState(0);
    const [currentPageSize, setCurrentPageSize] = useState(10);

    // Variables for search
    const [clientSearch, setClientSearch] = useState("");

    let [clients, setClients] = useState([])
    
    let getClients = async () => {
        let response = await fetch(`${API_URL}/submissions/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })
        let data = await response.json()
        setClients(data)
    }

    let batchDelete = async (selectedClients) => {
        selectedClients.map((client) => deleteClient(client.id))
    }

    useEffect(() => {
        getClients()
        document.title = "Submissions | WillowBMS"
    }, [])

    const showToast = (type, title, description) => {
        const id = Math.floor((Math.random() * 100) + 1);
        const time = new Date().toLocaleString();

        switch (type) {
            case 'success':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'success',
                    time: time
                }
                break;
            case 'error':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'error',
                    time: time
                }
                break;
            case 'info':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'info',
                    time: time
                }
                break;
            case 'warning':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'warning',
                    time: time
                }
                break;
            default:
                setList([]);
        }
        setList([...list, toastProperties]);
    }

    let deleteClient = async (submissionID) => {
        let response = await fetch(`${API_URL}/submissions/${submissionID}/`, {
            method: 'DELETE',
            'headers': {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })

        if (response.status === 200) {
            showToast("success", "Success", "Submission(s) have been deleted.")
            getClients()
            setError(false)
            setOpenDeleteModal(false)
        } else {
            setError(true)
        }
    }

    const clientsData = useMemo(() => {
        let computedClients = search(clients);
        setTotalItems(computedClients.length);
        //Current Page slice
        return computedClients.slice(
            firstRowIndex,
            firstRowIndex + currentPageSize
        );
    }, [clients, firstRowIndex, currentPageSize, clientSearch]);

    const clientListHeaders = [
        { label: "ID", key: "id" },
        { label: "First Name", key: "fname" },
        { label: "Last Name", key: "lname" },
        { label: "Entity Name", key: "entityname" },
        { label: "Phone Number", key: "phone" },
        { label: "Client Since", key: "signeddate" },
        { label: "Agreement Type ID", key: "type" },
        { label: "Agreement Type", key: "typename" },
        { label: "Email Address", key: "email" },
        { label: "Contact Street 1", key: "street" },
        { label: "Contact Street 2", key: "street2" },
        { label: "Contact City", key: "city" },
        { label: "Contact State", key: "state" },
        { label: "Contact Country", key: "country" },
        { label: "Contact Zip Code", key: "postalcode" },
        { label: "Property Street 1", key: "propertystreet" },
        { label: "Property Street 2", key: "propertystreet2" },
        { label: "Property City", key: "propertycity" },
        { label: "Property County", key: "county" },
        { label: "Property State", key: "propertystate" },
        { label: "Property Country", key: "propertycountry" },
        { label: "Property Zip Code", key: "propertypostalcode" },
        { label: "Property Folio", key: "folio" },
    ];

    const clientListReport = {
        data: clients,
        headers: clientListHeaders,
        filename: `all_submissions_list_report.csv`
    };

    function search(clients) {
        return clients.filter(
            (row) =>
                row.fname.toLowerCase().indexOf(clientSearch) > -1 ||
                row.fname.indexOf(clientSearch) > -1
        );
    }

    return (
        <div id="body" className="bms-page d-flex">
            <Toast toastList={list} />
            <div className="wrapper">
                <Breadcrumb>
                    <BreadcrumbItem href="/">Submissions</BreadcrumbItem>
                </Breadcrumb>
                <h2>
                    Submission List
                </h2>

                <AgreementsList clientListReport={clientListReport} setClientsToDel={setClientsToDel} clientsToDel={clientsToDel} error={error} setError={setError} setOpenDeleteModal={setOpenDeleteModal} openDeleteModal={openDeleteModal} batchDelete={batchDelete} rows={clientsData} totalItems={totalItems} currentPageSize={currentPageSize} setCurrentPageSize={setCurrentPageSize} setFirstRowIndex={setFirstRowIndex} setClientSearch={setClientSearch} />

            </div>
        </div>
    )
}

export default SubmissionList